import { Box, Grid, Skeleton, Stack } from "@mui/material";

const MainProductCard = ({ isRowLoader, small }) => {
  return isRowLoader ? (
    Array(9)
      .fill(1)
      .map((_d, i) => (
        <Grid item xs={12} sm={6} md={4} key={i}>
          <Box className="h-290 mx-auto py-3 px-2 flex-column items-center shadow bg-white rounded-10">
            <Skeleton
              variant="rectangular"
              width="100%"
              height={150}
              className="rounded-5"
            />
            <div className="w-full">
              <Skeleton
                variant="text"
                sx={{ fontSize: "1rem" }}
                className="mt-2"
              />
              <Skeleton
                variant="text"
                sx={{ fontSize: "0.8rem" }}
                className="mt-2"
              />
              <Skeleton
                variant="text"
                sx={{ fontSize: "0.5rem" }}
                className="w-50p mt-3"
              />
            </div>
          </Box>
        </Grid>
      ))
  ) : (
    <Box className="w-full ml-3">
      {Array(small ? 6 : 3)
        .fill(1)
        .map((_d, i) => (
          <div
            className="w-full flex items-stretch relative mb-3 shadow bg-white px-2 py-2 rounded-10"
            key={i}
          >
            <Skeleton
              variant="rectangular"
              width={!!small ? 190 : 300}
              height={!!small ? 120 : 180}
              className="rounded-10"
            />
            <div className="flex-1 h-full ml-3 mr-1">
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="start"
                mb={2}
              >
                <Skeleton variant="text" width="40%" height={30} />
                <Skeleton variant="circular" width={32} height={32} />
              </Box>

              {/* PARAGRAPH */}
              <Skeleton variant="text" width="100%" height={10} />
              <Skeleton variant="text" width="90%" height={10} />
              <Skeleton
                variant="text"
                width="80%"
                height={10}
                className="mb-8"
              />
              {/* RELATED COUNTS */}
              {!small && (
                <Skeleton
                  variant="text"
                  width="90%"
                  height={20}
                  className="mt-10"
                />
              )}

              {/* TAG BUTTONS */}
              {!small && (
                <Stack direction="row" spacing={1} mt={1}>
                  {[...Array(3)].map((_, index) => (
                    <Skeleton
                      key={index}
                      variant="rounded"
                      width={90}
                      height={20}
                    />
                  ))}
                </Stack>
              )}
            </div>
          </div>
        ))}
    </Box>
  );
};
export default MainProductCard;
